<template>
	<div class="forms content">
		<component :is="href('/interactions/forms/details').content" />
		<form ref="form" v-show="showForm" v-on:submit.prevent="sendMail">
			<label><font-awesome-icon icon="building" /> {{ href("/interactions/forms/details").meta.company }}</label>
			<input class="company" name="company" type="text" v-model="company" required/>
			<label><font-awesome-icon icon="users" /> {{ href("/interactions/forms/details").meta.customers }}</label>
			<label class="checkbox">
				<input type="checkbox" name="customers" :value="frontdesk" v-model="customers" />
				<span class="indicator"></span>
				<span class="label">{{ href("/interactions/forms/details").meta.frontdesk }}</span>
			</label>
			<label class="checkbox">
				<input type="checkbox" name="customers" :value="storefront" v-model="customers" />
				<span class="indicator"></span>
				<span class="label">{{ href("/interactions/forms/details").meta.storefront }}</span>
			</label>
			<label class="checkbox">
				<input type="checkbox" name="customers" :value="callCenter" v-model="customers" />
				<span class="indicator"></span>
				<span class="label">{{ href("/interactions/forms/details").meta.callCenter }}</span>
			</label>
			<label class="checkbox">
				<input type="checkbox" name="customers" :value="online" v-model="customers" />
				<span class="indicator"></span>
				<span class="label">{{ href("/interactions/forms/details").meta.online }}</span>
			</label>
			<label><font-awesome-icon icon="funnel-dollar" /> {{ href("/interactions/forms/details").meta.spend }}</label>
			<label v-for="spendOption of spendOptions" class="radio" :key="spendOption">
				<input type="radio" name="spend" v-model="spend" :value="spendOption" />
				<span class="indicator"></span>
				<span class="label">{{ spendOption	}}</span></label
			>
			<input
				type="hidden"
				name="subject"
				:value="href('/interactions/forms/details').meta.subject"
			/>
			<input
				type="hidden"
				name="message"
				:value="href('/interactions/forms/details').meta.message"
			/>
			<input type="hidden" name="context" value="demo-forms" />
			<div class="actions">
				<button type="submit">{{ href("/interactions/forms/details").meta.send }}</button>
			</div>
		</form>
	</div>
</template>

<script>
import hreflang from '@/lib/hreflang'
import { mapState } from 'vuex'

export default {
	name: 'FromsInteraction',
	mixins: [hreflang],
	props: {
		showDetails: Boolean,
	},
	data() {
		return {
			customers: [],
			sending: false,
			company: '',
			spend: '',
		}
	},
	computed: {
		...mapState({
			passport: state => state.demo.passport,
			lang: state => state.settings.lang,
		}),
		frontdesk() {
			return this.href('/interactions/forms/details').meta.frontdesk
		},
		storefront() {
			return this.href('/interactions/forms/details').meta.storefront
		},
		callCenter() {
			return this.href('/interactions/forms/details').meta.callCenter
		},
		online() {
			return this.href('/interactions/forms/details').meta.online
		},
		spendOptions() {
			return this.href('/interactions/forms/details').meta.spendOptions
		},
		showForm() {
			return !this.sending && this.showDetails
		},
	},
	watch: {
		passport() {
			return this.initPassport()
		}
	},
	methods: {
		initPassport() {
			if (this.passport && this.passport.identities) {
				let identity = this.passport.identities.find(
					(identity) => identity.id == 'company'
				)
				if (identity && !this.company) {
					this.company = identity.value
					this.identity = true
				}
			}
		},
		sendMail() {
			window.whitebox.init('mail', (mail) => {
				if (mail) {
					mail.service.apply(this.$refs.form)
					this.sending = true
				}
			})
		},
	},
	created() {
		this.document(require('documents/en/interactions/forms-details.md'), 'en')
	},
	mounted() {
		this.initPassport()
	},
}
</script>

<style scoped lang="less">
@import url("~whitebox-presentation/src/assets/variables.less");
@import url("~whitebox-presentation/src/assets/mixins.less");

form {
	margin-top: @gap * 2;
}
.content {
	padding: 0;
}

.company {
	width: 60%;
	margin-right: @gap * 4;
}
.actions {
	margin-top: 2 * @gap;
}
.checkbox {
	margin-right: @gap * 2;
	margin-bottom: @gap;
}
.radio {
	display: block;
}
</style>
